import { FormControl } from "@angular/forms";
export function EmailValidator(control: FormControl) {
	if (control.value) {
		const emailRegEx =
			/^(([^<>(){}%^`\[\]\\.,;:\s@"]+(\.[^<>(){}%^`\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		const valid = emailRegEx.test(control.value);
		return valid
			? null
			: {
					emailInvalid: {
						valid: false,
						message: "Please enter a valid email",
					},
					// tslint:disable-next-line: indent
			  };
	}
}
